// Make.com Webhook Integration
// Sends registration data after successful payment

export interface MakeWebhookData {
  type: string
  name: string
  email: string
  phone: string
  orderNumber: string
  ticketType: string
  price: string
  gender: string
  companionName?: string
  companionPhone?: string
  companionGender?: string
  nightChoice?: string
  roomType?: string
  roommate1?: string
  roommate2?: string
  competitiveTrack?: string
  rowingType?: string
  clubName?: string
  rentBoard?: string
  whatsappGroup?: string
  source: string
  paid: boolean

  // Meta Ads UTM Parameters
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string // Meta ad set/targeting info
  utm_id?: string // Meta campaign ID
  fbclid?: string
}

export async function sendToMake(data: MakeWebhookData): Promise<boolean> {
  const MAKE_WEBHOOK_URL =
    'https://hook.eu2.make.com/lrvn3a2u4kdjz84np141pmwu3d7hlrsb'

  try {
    console.log('🚀 Sending to Make.com:', data)

    const response = await fetch(MAKE_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      throw new Error(`Make.com webhook failed: ${response.status}`)
    }

    console.log('✅ Successfully sent to Make.com')
    return true
  } catch (error) {
    console.error('❌ Error sending to Make.com:', error)
    return false
  }
}
